module.exports = "/images/logo.png?20b392a8c213c699b5d59d116f1092e6";